import { getSubdomain } from "@/utils/tenant";
import api from "@/services/api";
// import mockTenant from "@/utils/mockTenant";

const state = {
	subdomain: "",
	data: null, // will hold the full tenant payload (mock or API raw object)
	loading: false,
	error: null,
};

const mutations = {
	SET_SUB(state, v) {
		state.subdomain = v;
	},
	SET_LOADING(state, v) {
		state.loading = v;
	},
	SET_DATA(state, v) {
		state.data = v;
	},
	SET_ERROR(state, v) {
		state.error = v;
	},
};

const actions = {
	async init({ commit, state }) {
		// skip if we already initialized or are loading
		if (state.loading || state.data || state.error !== null) {
			return;
		}

		commit("SET_LOADING", true);
		commit("SET_ERROR", null);

		const sub = getSubdomain();
		// const sub = "mannery"; // for testing purposes, use a fixed subdomain
		commit("SET_SUB", sub);

		// const devMode =
		// 	process.env.VUE_APP_DEV === "True" || process.env.VUE_APP_DEV === "true";
		// if (devMode && !sub) {
		// 	console.log("[tenant] Using mock tenant data (local mode)");
		// 	commit("SET_DATA", mockTenant);
		// 	commit("SET_LOADING", false);
		// 	return;
		// }

		if (!sub) {
			// no subdomain and not dev-mode → nothing to do
			commit("SET_LOADING", false);
			return;
		}

		try {
			const res = await api.getTenant(sub);

			// Extract tenant object whether res.data is array or single object
			let t = null;
			if (res?.data) {
				t = Array.isArray(res.data) ? res.data[0] : res.data;
			}

			if (!t) {
				commit("SET_DATA", null);
				return;
			}

			// Commit the full raw tenant object so UI expecting mockTenant's shape works unchanged
			// Also attach a small normalized view under `normalized` to keep the convenience mapping
			const normalized = {
				id: t.ID ?? t.id ?? null,
				name: t.Name ?? t.name ?? t.handle ?? null,
				logoUrl: t.Logo ?? t.logo_url ?? t.logoUrl ?? t.logo ?? null,
				description: t.Description ?? t.description ?? null,
				email: t.Email ?? t.email ?? null,
				phone: t.Phone ?? t.phone ?? null,
				handle: t.handle ?? t.Handle ?? null,
			};

			// Build a combined payload: raw tenant under `raw` and a `normalized` quick view.
			// Your UI that previously read `mockTenant.past_events` can still read `state.data.past_events`
			const payload = {
				...t, // raw tenant fields (past_events, active_events, etc.)
				normalized, // convenience small view
			};

			commit("SET_DATA", payload);
		} catch (e) {
			commit("SET_ERROR", e?.message || "Tenant not found");
			commit("SET_DATA", null);
		} finally {
			commit("SET_LOADING", false);
		}
	},
};

const getters = {
	tenantSub: (s) => s.subdomain,
	tenant: (s) => s.data,
	tenantLoading: (s) => s.loading,
	tenantError: (s) => s.error,
};

export default { namespaced: true, state, mutations, actions, getters };
